import type { ScreenParts } from 'components/app/routes/app-routes-revamp';

export const OrderCompleteTemplate = (props: ScreenParts) => {
  const { Content } = props;

  return <>{Content && <Content />}</>;
};

export default OrderCompleteTemplate;
